import { Model, store } from "hybrids";
import { get } from "~/utils/api";

interface Card {
  id: string;
  name: string;
  expirationMonth: string;
  expirationYear: string;
  last4: string;
}

interface PaymentMethods {
  id: string;
  stripe: {
    key: string;
    account: string;
    country: string;
    cards: Card[];
  };
  paypal: {
    clientId: string;
    env: string;
  };
  currency: string;

  // computed
  disabled: boolean;
}

const Card: Model<Card> = {
  id: true,
  name: "",
  expirationMonth: "",
  expirationYear: "",
  last4: "",
};

const PaymentMethods: Model<PaymentMethods> = {
  id: true,
  stripe: {
    key: "",
    account: "",
    country: "US",
    cards: [Card],
  },
  paypal: {
    clientId: "",
    env: "",
  },
  currency: "",

  // computed
  disabled: (methods) => !methods.stripe.account && !methods.paypal.clientId,

  [store.connect]: (id) => get("/payment_methods", { ownerId: id as string }),
};

export default PaymentMethods;
